var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.505025 9.00503C0.231658 9.27839 0.231658 9.72161 0.505025 9.99497C0.778392 10.2683 1.22161 10.2683 1.49497 9.99497L0.505025 9.00503ZM9.7 1.5C9.7 1.1134 9.3866 0.8 9 0.8L2.7 0.8C2.3134 0.8 2 1.1134 2 1.5C2 1.8866 2.3134 2.2 2.7 2.2L8.3 2.2L8.3 7.8C8.3 8.1866 8.6134 8.5 9 8.5C9.3866 8.5 9.7 8.1866 9.7 7.8L9.7 1.5ZM1.49497 9.99497L9.49497 1.99498L8.50502 1.00503L0.505025 9.00503L1.49497 9.99497Z",
    fill: "#3359D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpSmall);
export default __webpack_public_path__ + "static/media/Arrow_up_small.1148b84b2010cf508151bc5295f01985.svg";
export { ForwardRef as ReactComponent };